import { render, staticRenderFns } from "./ExpectedOrdersTable.vue?vue&type=template&id=635eeb1d&lang=pug"
import script from "./ExpectedOrdersTable.vue?vue&type=script&lang=ts"
export * from "./ExpectedOrdersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports